import templateUrl from "emun.order/parse-items/order-parse-items.htm";
import OrderParseItemsController from "emun.order/parse-items/order-parse-items.controller";
import open from "webmodals/open";

let OrderParseItems = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
	controller: OrderParseItemsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderParseItems;
